import { useEffect } from 'react';
import ReactGA from 'react-ga';

const InitGA = ({
  id,
  debug = false
}) => {
  useEffect(() => {
    ReactGA.initialize(id, {
      debug
    });
  }, [debug, id]);
  return null;
};

export default InitGA;